"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formRules = exports.defaultFormData = void 0;
var defaultFormData = exports.defaultFormData = {
  batchName: '',
  // 名称
  couponId: '',
  // 优惠券id
  totalCount: 0,
  // 发放数量
  remark: '' // 备注
};
var formRules = exports.formRules = {
  batchName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入批次名称'
  }],
  couponId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择优惠券'
  }],
  totalCount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入发放数量'
  }]
};